class QestionService {

  /**
   * 
   */
  getListData(rows) {

    //*****************
    //公民は4階層で、それ以外は3階層
    //*****************
    if (process.env.SUBJECT == "civics") {

      //空欄を埋める
      $.each(rows, function(idx, row){
        if (idx) {
          if (row[1].trim() == "") {
            row[1] = rows[idx - 1][1]
          }
          if (row[2].trim() == "") {
            row[2] = rows[idx - 1][2]
          }
          if (row[3].trim() == "") {
            row[3] = rows[idx - 1][3]
          }
          if (row[4].trim() == "") {
            row[4] = rows[idx - 1][4]
          }
        }
      })

      //データ取得
      var list = []
      $.each(rows, function(idx, row){
        if (row != "") {
          var largeCate = row[1]
          var middleCate = row[2]
          var smallCate = row[3]
          var title = row[4]
          var answer = row[5]
          var question = row[6]
          list.push({"id": idx, "depth1": largeCate, "depth2": middleCate, "depth3": smallCate, "depth4": title, "text" : title, "question": question, "answer": answer})
        }
      })

    }
    //*****************
    //地理、歴史は3階層
    //*****************
    else {

      //空欄を埋める
      $.each(rows, function(idx, row){
        if (idx) {
          if (row[1].trim() == "") {
            row[1] = rows[idx - 1][1]
          }
          if (row[2].trim() == "") {
            row[2] = rows[idx - 1][2]
          }
          if (row[3].trim() == "") {
            row[3] = rows[idx - 1][3]
          }
        }
      })

      //データ取得
      var list = []
      $.each(rows, function(idx, row){
        if (row != "") {
          var largeCate = row[1]
          var middleCate = row[2]
          var smallCate = row[3]
          var answer = row[4]
          var question = row[5]
          list.push({"id": idx, "depth1": largeCate, "depth2": middleCate, "depth3": smallCate, "text" : smallCate, "question": question, "answer": answer})  
        }
      })
    }    

    return list
  }

  /**
   * 
   */
  getTreeData(list) {

    //大分類
    var largeArray = list.reduce((p, x) => (p.indexOf(x.depth1) !== -1) ? p : [...p, x.depth1], [])

    //*****************
    //公共の場合のみ、4階層
    //*****************
    if (process.env.SUBJECT == "civics") {

      //タイトル
      var titleArray = list.reduce((p, x) => (p.indexOf(x.depth1 + ":" + x.depth2 + ":" + x.depth3 + ":" + x.depth4) !== -1) ? p : [...p, x.depth1 + ":" + x.depth2 + ":" + x.depth3 + ":" + x.depth4], [])
        
      //タイトルのループ
      var bottomData = []
      $.each(titleArray, function(idx4, row4){
        var array = row4.split(":")
        var childrenTitle = list.filter(row => row.depth1 == array[0] && row.depth2 == array[1] && row.depth3 == array[2] && row.text == array[3])

        //var str = array[3] + "（" + childrenTitle.length + "問）"
        var str = array[3]
        str += "<div class='qrow'>";
        str += childrenTitle.length + "問";
        str += "</div>";

        /*
        var str = "<div unselectable='on' role='presentation' class='jstree-wholerow'>&nbsp;</div>";
        str += "<a class='jstree-anchor' href='#' tabindex='-1'>";
        str += "<div class='box-l'>";
        str += "<span>" + array[3] + "</span>";
        str += "</div>";
        //str += "<div class='box-r' style='width:620px; text-align:right'>";
        str += "<div class='box-r'>";
        str += "<span>" + childrenTitle.length + "問</span>";
        str += "</div>";
        str += "</a>";     
        */    
         
        bottomData.push({
          "id": "q" + idx4,
          "text": str,
          "nodes": childrenTitle,
          "key": array[0] + ":" + array[1] + ":" + array[2] + ":" + array[3] 
        }) 
      })
      
      function getNthChildren(parent, depth) {

        if (depth == 4) {
          return bottomData.filter(row => row.key.indexOf(parent) !== -1)
        }

        var children = list.reduce((p, x) => (p.indexOf(parent + ":" + x["depth" + String(depth)]) !== -1) ? p : [...p, parent + ":" + x["depth" + String(depth)]], [])
        var ret = []
        $.each(children, function(idx, row){

          var str = row.split(":")[depth - 1];
          str += "<div class='qrow'></div>";  //チェックボックスのヒットエリア用の空ノード

          var wk = getNthChildren(row, depth + 1)
          if (wk.length > 0) {
            ret.push({
              "text": str,
              "children": wk
            })   
          }
        })
        return ret
      }

      //大分類のループ
      var treeData = []
      $.each(largeArray, function(idx, row){

        var str = row;
        str += "<div class='qrow'></div>";  //チェックボックスのヒットエリア用の空ノード
  
        treeData.push({
          "text": str,
          "children": getNthChildren(row, 2)
        })
      })
    
    }
    //*****************
    //地理、歴史は3階層
    //*****************
    else {

      //タイトル
      var titleArray = list.reduce((p, x) => (p.indexOf(x.depth1 + ":" + x.depth2 + ":" + x.depth3) !== -1) ? p : [...p, x.depth1 + ":" + x.depth2 + ":" + x.depth3], [])
        
      //タイトルのループ
      var bottomData = []
      $.each(titleArray, function(idx, row){
        var array = row.split(":")
        var childrenTitle = list.filter(row => row.depth1 == array[0] && row.depth2 == array[1] && row.depth3 == array[2])        
        
        var str = array[2]
        //var str = "<div class='trow'>" + array[2] + "</div>"
        str += "<div class='qrow'>";
        str += childrenTitle.length + "問";
        str += "</div>";
        
        bottomData.push({
          "id": "q" + idx,
          "text": str,
          "nodes": childrenTitle,
          "key": array[0] + ":" + array[1] + ":" + array[2]
        }) 
      })
      
      function getNthChildren(parent, depth) {

        if (depth == 3) {
          return bottomData.filter(row => row.key.indexOf(parent) !== -1)
        }

        var children = list.reduce((p, x) => (p.indexOf(parent + ":" + x["depth" + String(depth)]) !== -1) ? p : [...p, parent + ":" + x["depth" + String(depth)]], [])
        var ret = []
        $.each(children, function(idx, row){

          var str = row.split(":")[depth - 1];
          str += "<div class='qrow'></div>";  //チェックボックスのヒットエリア用の空ノード
          
          var wk = getNthChildren(row, depth + 1)
          if (wk.length > 0) {
            ret.push({
              "text": str,
              "children": wk
            })   
          }
        })
        return ret
      }

      //大分類のループ
      var treeData = []
      $.each(largeArray, function(idx, row){

        var str = row;
        str += "<div class='qrow'></div>";  //チェックボックスのヒットエリア用の空ノード
  
        treeData.push({
          "text": str,
          "children": getNthChildren(row, 2)
        })
      })
    
    }
    /*   
    //大分類
    var largeArray = list.reduce((p, x) => (p.indexOf(x.large) !== -1) ? p : [...p, x.large], [])
    //中分類
    var middleArray = list.reduce((p, x) => (p.indexOf(x.large + ":" + x.middle) !== -1) ? p : [...p, x.large + ":" + x.middle], [])
    //小分類
    var smallArray = list.reduce((p, x) => (p.indexOf(x.large + ":" + x.middle + ":" + x.small) !== -1) ? p : [...p, x.large + ":" + x.middle + ":" + x.small], [])

    //タイトル
    if (process.env.SUBJECT == "civics") {
      var titleArray = list.reduce((p, x) => (p.indexOf(x.large + ":" + x.middle + ":" + x.small + ":" + x.text) !== -1) ? p : [...p, x.large + ":" + x.middle + ":" + x.small + ":" + x.text], [])
      
      var treeData = []
      //大分類のループ
      $.each(largeArray, function(idx, row){

        //中分類のループ
        var childrenLarge = []
        $.each(middleArray, function(idx2, row2){
          var array2 = row2.split(":")
          if (row == array2[0]) {

            //小分類のループ
            var childrenMiddle = []
            $.each(smallArray, function(idx3, row3){
              var array3 = row3.split(":")
              if (array2[0] == array3[0] && array2[1] == array3[1]) {

                //タイトルのループ
                var childrenSmall = []
                $.each(titleArray, function(idx4, row4){
                  var array = row4.split(":")
                  if (array3[0] == array[0] && array3[1] == array[1] && array3[2] == array[2]) {
                    //問題
                    var childrenTitle = list.filter(row => row.large == array[0] && row.middle == array[1] && row.small == array[2] && row.text == array[3])
  
                    childrenSmall.push({
                      "id": "q" + idx4,
                      "text": array[3] + "(" + childrenTitle.length + "問)",
                      "nodes": childrenTitle
                    }) 
                  }
                })

                //小分類
                childrenMiddle.push({
                  "text": array3[2],
                  "children": childrenSmall
                }) 

              }  
            })

            //中分類
            childrenLarge.push({
              "text": array2[1],
              "children": childrenMiddle
            })
          }
        })

        //大分類
        treeData.push({
          "text": row,
          "children": childrenLarge
        })
      })
    }
    else {

      //小分類
      var smallArray = list.reduce((p, x) => (p.indexOf(x.large + ":" + x.middle + ":" + x.small) !== -1) ? p : [...p, x.large + ":" + x.middle + ":" + x.small], [])
      //タイトル
      var titleArray = list.reduce((p, x) => (p.indexOf(x.large + ":" + x.middle + ":" + x.small + ":" + x.text) !== -1) ? p : [...p, x.large + ":" + x.middle + ":" + x.small + ":" + x.text], [])
        
      var treeData = []
      //大分類のループ
      $.each(largeArray, function(idx, row){

        //中分類のループ
        var childrenLarge = []
        $.each(middleArray, function(idx2, row2){
          var array2 = row2.split(":")
          if (row == array2[0]) {

            //小分類のループ
            var childrenMiddle = []
            $.each(smallArray, function(idx3, row3){
              var array3 = row3.split(":")
              if (array2[0] == array3[0] && array2[1] == array3[1]) {
              
                //問題
                var childrenTitle = list.filter(row => row.large == array3[0] && row.middle == array3[1] && row.small == array3[2])

                //小分類
                childrenMiddle.push({
                  "id": "q" + idx3,
                  "text": array3[2] + "(" + childrenTitle.length + "問)",
                  "nodes": childrenTitle
                }) 

              }  
            })

            //中分類
            childrenLarge.push({
              "text": array2[1],
              "children": childrenMiddle
            })
          }
        })

        //大分類
        treeData.push({
          "text": row,
          "children": childrenLarge
        })
      })

    }
    */

/*
    var treeData = [
      {
        'text' : '大分類1',
        'state' : {
          'opened' : false,
          'selected' : false
        },
        'children' : [
          {'text' : '中分類1', 'children': [
            { "id": "q1", 'text' : '問題1', 'question': 'qqqqqq2',  'answer': 'aaaaaaaa2'},
            { "id": "q2", 'text' : '問題2', 'question': 'qqqqqq2',  'answer': 'aaaaaaaa2'}
          ]}
        ],
      },
      {
        'text' : '大分類2',
        'children' : [
          {'text' : '中分類3', 'children': [
            { "id": "q3", 'text' : '問題3', 'question': 'qqqqqq2',  'answer': 'aaaaaaaa2'},
            { "id": "q4", 'text' : '問題4', 'question': 'qqqqqq2',  'answer': 'aaaaaaaa2'}
          ]}
        ],
      }
    ]
*/
    return treeData
  }

}
export default new QestionService()



// WEBPACK FOOTER //
// ./src/service/QestionService.js